import { render, staticRenderFns } from "./LastSeenArticles.vue?vue&type=template&id=6fc4e53a&scoped=true"
import script from "./LastSeenArticles.vue?vue&type=script&lang=js"
export * from "./LastSeenArticles.vue?vue&type=script&lang=js"
import style0 from "./LastSeenArticles.vue?vue&type=style&index=0&id=6fc4e53a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc4e53a",
  null
  
)

export default component.exports